export default __webpack_public_path__ + "static/media/details-3.f525a3c8.jpg";